const init = () => {
  const hash = location.hash;
  const $target = $(hash);

  if ($target.length <= 0) return;

  const params = {
    duration: 1,
    scrollTo: {
      y: hash,
      // トップに戻る以外はグローバルヘッダの高さをオフセットする(SPサイズ以上)
      offsetY:
        hash === ("#home" || !isSpSize())
          ? 0
          : document.querySelector("#global_header").offsetHeight,
    },
    ease: "power4.out",
  };

  gsap.to(window, params);
};

export { init };
